import { ReactElement, useMemo } from 'react'
import { useUserStore } from '../../../../../../src/store/user/UserStore'
import logoUrl from 'src/assets/images/logo.png'
import styled from 'styled-components'
import Summary from './summary'
import { VehicleInfoProps } from '../../../../../../src/features/SummaryPanel/Interfaces'
import VehicleReceipt from './vehicle/VehicleReceipt'
import { OrderResponse } from '../../../../../../src/api/cart/interfaces'
import { ISeller } from '../../../../../../src/services/MultiSellerServicesProvider'
import { toLocaleDateString } from '../../../../../../src/helpers/date'
import ReceiptHeader from './ReceiptHeader'
import { ReceiptGlobalPrintStyle } from './printStyles'

interface Props {
  showYourCost: boolean
  vehicles: VehicleInfoProps[]
  grandTotal: number
  orderResponse?: OrderResponse
  sellersData: ISeller[]
  orderDate?: string
}

const Receipt = (props: Props): ReactElement => {
  const {
    showYourCost,
    vehicles,
    grandTotal,
    orderResponse,
    sellersData,
    orderDate: orderDateProp,
  } = props

  const userStore = useUserStore()
  const userLogoUrl = useMemo(
    () => userStore.userLogo || logoUrl,
    [userStore.userLogo]
  )
  const displayExclTax = userStore?.preferences?.displayExclTax === 'true'

  const vehicleCarts = orderResponse?.orderDetails
  const orderDate = orderDateProp ?? toLocaleDateString(new Date())

  return (
    <>
      <ReceiptGlobalPrintStyle />
      <Wrapper>
        <PrintContent>
          <ReceiptHeader logoUrl={userLogoUrl} orderDate={orderDate} />
          <Summary
            grandTotal={grandTotal}
            vehicles={vehicles}
            showYourCost={showYourCost}
            displayExclTax={displayExclTax}
          />
          {vehicleCarts?.map((orderDetails, index) => {
            return (
              <VehicleReceipt
                key={`print_cart_item_${index}`}
                showYourCost={showYourCost}
                orderDetails={orderDetails}
                vehicleInfo={vehicles[index]}
                sellersData={sellersData}
                orderDate={orderDate}
                isFirstVehicle={index === 0}
                logoUrl={userLogoUrl}
                displayExclTax={displayExclTax}
              />
            )
          })}
        </PrintContent>
      </Wrapper>
    </>
  )
}

const Wrapper = styled.div`
  visibility: hidden;
  position: absolute;
  top: -9999px;
  left: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  width: 7.7in;

  @media print {
    visibility: visible;
    position: static;
    top: 0;
    width: 100%;
  }
`

const PrintContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export default Receipt
